"use strict";
var _a;
var _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.userReducer = exports.clearCredentials = exports.setCredentials = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var auth_storage_1 = require("../../utils/auth-storage");
var emptySession = {
    uid: "",
    email: "",
    token: "",
    refreshToken: "",
    expiresIn: "",
    sessionId: "",
};
var initialState = (_b = (0, auth_storage_1.loadAuthSession)()) !== null && _b !== void 0 ? _b : emptySession;
var userSlice = (0, toolkit_1.createSlice)({
    name: "userSlice",
    initialState: initialState,
    reducers: {
        setCredentials: function (state, action) {
            var _a = action.payload, uid = _a.uid, email = _a.email, token = _a.token, refreshToken = _a.refreshToken, expiresIn = _a.expiresIn, sessionId = _a.sessionId, keepSignedIn = _a.keepSignedIn, user = _a.user;
            state.uid = uid;
            state.email = email;
            state.token = token;
            state.refreshToken = refreshToken;
            state.expiresIn = expiresIn;
            state.sessionId = sessionId;
            state.keepSignedIn = keepSignedIn;
            state.user = user;
        },
        clearCredentials: function () { return emptySession; },
    },
});
exports.setCredentials = (_a = userSlice.actions, _a.setCredentials), exports.clearCredentials = _a.clearCredentials;
exports.userReducer = userSlice.reducer;
